import React, { useEffect, useRef, useState } from "react";
import Modal from "react-bootstrap/Modal";
import TableComponent from "../../Common/TableComponent/tableComponent";
import { useForm } from "react-hook-form";
import {
  GetAllContainerCapacity,
  GetAllContainerType,
  createContainerMaster,
  getAllContainerMaster,
  getContainerById,
  updateContainerMaster,
} from "../../Apis/containerMasterApi";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import imageCompression from "browser-image-compression";
import Loader from "../../Common/Loader/loader";
import { withTranslation } from "react-i18next";
import { jsPDF } from "jspdf";
import { AllVehicleStatusDetails } from "../../Apis/vehicleApi";
import * as XLSX from "xlsx"; // Import XLSX library for Excel operations
import JSZip from 'jszip';
import { saveAs } from 'file-saver';
import CustomDataTable from "../../Common/ReportTable/ReportTable";
import ExcelJS from "exceljs";
// import QRCode from "qrcode.react";
import QRCode from 'qrcode-svg'
const logoLSD = "/assets/media/image/logo-LSD.png";
const logoLMC = "/assets/media/image/LMC-LOGO.jpg";
const ContainerMaster = ({ t }) => {
  const navigate = useNavigate();
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm();
  const [isEditMode, setIsEditMode] = useState(false);
  const [lgShow, setLgShow] = useState(false);
  let dataPerPage = 5
  const headers = [
    "containerCode",
    "containerName",
    "containerUid",
    "containerType",
    "vehicleStatus",
    "qrCode",
    "status",
    "actions",
  ];
  const [containerData, setContainerData] = useState([]);

  const [editContainerData, setEditContainerData] = useState("");
  const [formInput, setFormInput] = useState({
    containerCapacity: "",
    containerCapacityId: "",
    containerCode: "",
    containerName: "",
    remarks: "",
    containerUuid: "",
    containerImageUrl: "",
    isActive: true,
    containerId: "",
    containerTypeId: "",
    vehicleStatusId: "",
    vehicleStatusName: "",
    containerTypeName: "",
  });
  const [editContainerId, setEditContainerId] = useState(null);
  const [isOptionsLoading, setIsOptionsLoading] = useState(true);
  const [selectedContainer, setSelectedContainer] = useState(null);
  const [selectedImage, setSelectedImage] = useState(null);
  const [imagePreview, setImagePreview] = useState(null);
  const resetRef = useRef(null);
  const [formSubmitted, setFormSubmitted] = useState(false);
  const [vehicleStatusDetails, setVehicleStatusDetails] = useState([]);
  const [containerCapacityData, setContainerCapacityData] = useState([]);
  const [containerTypeData, setContainerTypeData] = useState([]);
  const [sortedData, setSortedData] = useState([]); // New state to store sorted data
  const [excelData, setExcelData] = useState([]);
  const [originalData, setOriginalData] = useState([]);
  const [sortConfig, setSortConfig] = useState(null);
  const [filterOriginalContainerData, setFilterOriginalContainerData] = useState([]);

  let storedPermissions = localStorage.getItem('permissionId')
  const permissionValues1 = JSON.parse(localStorage.getItem('rolePermissions')) || {};
  let canWriteValue = null;

  // Convert storedPermissions to a number (if needed)
  storedPermissions = parseInt(storedPermissions, 10);

  // Find the matching roleToPermissionMapping object
  const matchingPermission = permissionValues1.find(mapping => mapping.permissionId === storedPermissions);

  if (matchingPermission) {
    canWriteValue = matchingPermission.canWrite;
    console.log(`canWrite value for permission ID ${storedPermissions}:`, canWriteValue);
  } else {
    console.log(`No match found for permission ID ${storedPermissions}`);
  }


  const resetFields = (reset) => {
    setFormInput({
      containerCapacity: "",
      containerCapacityId: "",
      containerCode: "",
      containerName: "",
      remarks: "",
      containerUuid: "",
      containerImageUrl: "",
      isActive: "",
      containerId: "",
      containerTypeId: "",
      vehicleStatusId: "",
      vehicleStatusName: "",
      containerTypeName: "",
    });
    resetRef.current();
  };

  useEffect(() => {
    resetRef.current = reset;
  }, [reset]);

  const handleClose = () => {
    resetFields();
    setLgShow(false);
    setIsEditMode(false);
    setSelectedContainer(null);
    setSelectedImage(null);
    setImagePreview(null);
    setFormSubmitted(false);
  };

  const scvCircleReportColumns = [
    {
      name: "S.No",
      width: "7%",
      selector: (row) => row["sno"],
      sortable: true,
      format: (row, rowIndex) => rowIndex + 1,
    },
    {
      name: "Container Code",
      // width: "10%",
      selector: (row) => (
        <span

        // onClick={() => handleZoneClick(row["zoneId"])}
        >
          {row["containerCode"]}
        </span>
      ),
      sortable: true,
    },
    {
      name: "containerUID",
      // width: "16%",
      selector: (row) => (
        <span
        // style={{ color: "blue", cursor: "pointer" }}
        // onClick={() => handleCircleClick(row["circleId"], row["zoneId"])}
        >
          {row["containerUuid"]}
        </span>
      ),
      sortable: true,
    },
    {
      name: "Container Type",
      // width: "16%",
      selector: (row) => (
        <span
        // style={{ color: "blue", cursor: "pointer" }}
        // onClick={() => handleCircleClick(row["circleId"], row["zoneId"])}
        >
          {row["containerType"]}
        </span>
      ),
      sortable: true,
    },
    {
      name: "Vehicle Status",
      // width: "19%",
      selector: (row) => <span>{row["vehicleStatus"]}</span>,
      sortable: true,
    },
    {
      name: "QRCode",
      // width: "16%",
      selector: (row) => (
        <span
        // style={{ color: "blue", cursor: "pointer" }}
        // onClick={() => handleCircleClick(row["circleId"], row["zoneId"])}
        >
          {row["qrCode"]}
        </span>
      ),
      sortable: true,
      
    },
    {
      name: "Status",
      // width: "16%",
      selector: (row) => (
        <span
        // style={{ color: "blue", cursor: "pointer" }}
        // onClick={() => handleCircleClick(row["circleId"], row["zoneId"])}
        >
          {row["status"]}
        </span>
      ),
      sortable: true,
    },
    {
      name: "Actions",
      // width: "16%",
      selector: (row) => (
        <span
        // style={{ color: "blue", cursor: "pointer" }}
        // onClick={() => handleCircleClick(row["circleId"], row["zoneId"])}
        >
          {row["actions"]}
        </span>
      ),
      sortable: true,
    },
    // {
    //   name: "No.of Helpers",
    //   // width: "14%",
    //   selector: (row) => (
    //     <span
    //     // style={{ color: "blue", width: "200px" }}
    //     // onClick={() => handleTwoTripClick(row, fromDate, toDate)}
    //     >
    //       {row["numberOfHelpers"]}
    //     </span>
    //   ),
    //   sortable: true,
    // },
  ];
  const handleEditContainer = async (selectedContainerData) => {
    setEditContainerData(selectedContainerData);
    setEditContainerId(selectedContainerData.id);
    setSelectedContainer(selectedContainerData);
    setLgShow(true);
    setIsOptionsLoading(true);
    setTimeout(() => {
      setIsOptionsLoading(false);
    }, 1000);

    setFormInput({
      ...formInput,
      containerCapacity: selectedContainerData.containerCapacityName,
      containerCapacityId: selectedContainerData.containerCapacityId,
      containerCode: selectedContainerData.containerCode,
      containerName: selectedContainerData.containerName,
      remarks: selectedContainerData.remarks,
      containerUuid: selectedContainerData.containerUuid,
      containerTypeId: selectedContainerData.containerTypeId,
      vehicleStatusId: selectedContainerData.vehicleStatusId,
      isActive: selectedContainerData.isActive,
      containerId: selectedContainerData.containerId,
      vehicleStatusName: selectedContainerData.vehicleStatusName,
      containerTypeName: selectedContainerData.containerTypeName,
      ...(selectedContainerData.containerImageUrl
        ? { containerImageUrl: selectedContainerData.containerImageUrl }
        : {}),  
    });
    console.log('Container Capacity:', selectedContainerData.containerCapacityId);
    setImagePreview(
      selectedContainerData.containerImageUrl
        ? selectedContainerData.containerImageUrl
        : null
    );
    reset();
  };

  const fetchContainer = async () => {
    setIsOptionsLoading(true);
    try {
      const response = await getAllContainerMaster();
      const containerDataResponse = response.data.map((container) => ({
        ...container,
        container: container.containerName,
        containerUid: container.containerUuid,
        containerType: container.containerTypeName,
        vehicleStatus: container.vehicleStatusName,
        status: container.isActive ? "Active" : "InActive",
      }));

      // Sort the data based on the isActive field
      const sortedInchargeData = containerDataResponse.sort((a, b) => {
        if (a.isActive === b.isActive) {
          return 0;
        }
        return a.isActive ? -1 : 1;
      });
      setContainerData(sortedInchargeData);
      setFilterOriginalContainerData(sortedInchargeData);
      console.log(sortedInchargeData, 'sortedInchargeData')

      // setContainerData(containerDataResponse);
      setIsOptionsLoading(false);
      setOriginalData(containerDataResponse);
    } catch (error) {
      console.error("Error fetching Deployment Container data:", error);
    }
  };


  const fetchVehicleStatusDetails = async () => {
    try {
      const vehicleStatusResponse = await AllVehicleStatusDetails(); // Fetch vehicle status details from the API
      setVehicleStatusDetails(vehicleStatusResponse); // Update state with vehicle status details
    } catch (error) {
      console.error("Error fetching vehicle status details:", error);
    }
  };

  const fetchContainerCapacity = async () => {
    try {
      const containerCapacityResponse = await GetAllContainerCapacity(); // Fetch vehicle status details from the API
      setContainerCapacityData(containerCapacityResponse.data); // Update state with vehicle status details

    } catch (error) {
      console.error("Error fetching containerCapacityResponse:", error);
    }
  };


  const fetchContainerType = async () => {
    try {
      const containerTypeResponse = await GetAllContainerType(); // Fetch vehicle status details from the API
      setContainerTypeData(containerTypeResponse.data); // Update state with vehicle status details
      console.log(containerCapacityData, 'containerssssdattaaaaaaaaaa');
    } catch (error) {
      console.error("Error fetching containerTypeResponse details:", error);
    }
  };


  const addNewContainer = async (data) => {
          setFormSubmitted(true);
    try {
      if (
        !formInput.containerName
        // || !formInput.remarks
        || !formInput.containerUuid
        || !formInput.containerCode
        || !formInput.containerCapacityId
        || !formInput.containerTypeId 
        || !formInput.vehicleStatusId
        // || !formInput.containerImageUrl
      ) {
        // toast.error("Please fill out all required fields correctly!");
        return;
      }

      setIsOptionsLoading(true);
      // await new Promise((resolve) => setTimeout(resolve, 1000));

      // if (
      //   !formInput.containerName
      //   // || !formInput.remarks
      //   || !formInput.containerUuid
      //   || !formInput.containerCode
      //   || !formInput.containerCapacity
      //   || !formInput.containerType
      //   || !formInput.vehicleStatus
      //   //|| !formInput.containerImageUrl
      //   // || !formInput.isActive
      // )
      // {
      //   // Display toast message indicating the required field
      //   // toast.error("Please fill out all required fields", {
      //   //   position: "top-right",
      //   //   autoClose: 5000,
      //   //   hideProgressBar: false,
      //   // });
      //   // Stop further execution
      //   return;
      // }

      const containerName = formInput.containerName || "";
      // const remarks = formInput.remarks || "";
      const containerUuid = formInput.containerUuid || "";
      const containerCode = formInput.containerCode || "";
      const containerCapacity = formInput.containerCapacity || "";
      const containerCapacityId = formInput.containerCapacityId || "";
      const containerTypeId = formInput.containerTypeId || "";
      const vehicleStatusId = formInput.vehicleStatusId || "";
      const vehicleStatusName = formInput.vehicleStatusName || "";
      const containerTypeName = formInput.containerTypeName || "";
      const remarks = formInput.remarks || "";
      //  const containerImageUrl = formInput.containerImageUrl || "";
      const containerId = formInput.containerId || "";
      // const isActive = formInput.isActive === "true";
      // const isActive = formInput.isActive || "";
      const isActive = selectedContainer ? formInput.isActive : true;
      // console.log(containerCapacityId,'containe capacity id');
      // console.log(containerCapacity,'containe capacity name');
      const requestData = {
        containerName,
        // remarks,
        containerUuid,
        containerCode,
        containerCapacity,
        containerCapacityId,
        containerTypeId,
        vehicleStatusId,
        isActive,
        remarks,
        // containerImageUrl: selectedImage || "",
        containerId,
        vehicleStatusName,
        containerTypeName,
      };
      if (selectedImage) {
        requestData.containerImageUrl = selectedImage;
      }
      if (selectedContainer) {
        const res = await updateContainerMaster(
          selectedContainer.id,
          requestData
        );
        const successMessage = "Container Updated Successfully!";
        toast.success(successMessage, {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
        fetchContainer();
        reset();
        handleClose();
        setSelectedImage(null);
        setImagePreview(null);
      } else {
        const res = await createContainerMaster(requestData);
        const successMessage = "Container Added Successfully!";
        toast.success(successMessage, {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
        fetchContainer();
        reset();
        handleClose();
        setSelectedImage(null);
        setImagePreview(null);
      }
    } catch (error) {
      
      if (error.response) {
        const { status, data } = error.response;
        // if (status === 400) {
        //   const validationErrors = data.errors;
        if (status === 400) {
          // Handle 409 status code errors
          const errorMessage = data;
          toast.error(errorMessage, {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
          });
        } else if (status === 409) {
          const errorMessage = data;
          toast.error(errorMessage, {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
          });
        } else {
      
        }
      } else {
       
      }
    } finally {
      setIsOptionsLoading(false);
    }
  };

  const handleKeyDown = (event, callback) => {
    if (event.key === "Enter" && event.shiftKey === false) {
      event.preventDefault();
      callback(addNewContainer);
    }
  };

  useEffect(() => {
    fetchContainer();
    fetchVehicleStatusDetails();
    fetchContainerCapacity();
    fetchContainerType();
  }, []);



  // const handleStatusChange = (e) => {
  //   const statusValue = e.target.id === "true" ? true : false;
  //   setFormInput((prevData) => ({
  //     ...prevData,
  //     status: statusValue,
  //   }));
  // };

  const handleStatusChange = (e) => {
    const { name, value } = e.target;
    setFormInput((prevData) => ({
      ...prevData,
      // [name]: value === "true" ? true : false,
      [name]: value === "true",
    }));
  };

  // image
  const handleImageChange = async (e) => {
    // const containerImageUrl = e.target.files[0];
    // setSelectedImage(containerImageUrl);
    const file = e.target.files[0];

    if (!file) return;
  
    // Validate file type (strict check)
    const allowedTypes = ["image/png", "image/jpeg", "image/jpg"];
    if (!allowedTypes.includes(file.type)) {
      toast.error("Only PNG, JPG, and JPEG images are allowed.");
      e.target.value = "";
      return;
    }
  
    setSelectedImage(file);

    try {
      // Compress the selected image
      const compressedImage = await compressImage(file);

      // Update selected image with the compressed image
      setSelectedImage(compressedImage);

      // Update form input with the compressed image URL
      setFormInput((prevData) => ({
        ...prevData,
        containerImageUrl: compressedImage || prevData.containerImageUrl,
      }));

      // Create a preview URL for the compressed image
      const previewURL = URL.createObjectURL(compressedImage);
      setImagePreview(previewURL);
    } catch (error) {
      console.error("Error compressing image:", error);
    }
  };


  const compressImage = async (file) => {
    const options = {
      maxSizeMB: 0.1,
      maxWidthOrHeight: 800,
    };
    try {
      const compressedFile = await imageCompression(file, options);

      // Create a new File object with the compressed image data
      const compressedImageFile = new File([compressedFile], file.name, {
        type: compressedFile.type,
      });
      return compressedImageFile;
    } catch (error) {
      console.error("Error compressing image:", error);
      return file;
    }
  };

  const handleViewContainerData = async (id) => {
    try {
      await new Promise((resolve) => setTimeout(resolve, 1000));
      setIsOptionsLoading(true);
      const response = await getContainerById(id);
      const containerDetails = response.data;
      navigate("/container-details", { state: { containerDetails } });
    } catch (error) {
    } finally {
      setIsOptionsLoading(false);
    }
  };

  const handleShow = () => {
    setLgShow(true);
    setIsOptionsLoading(true);
    setFormInput({
      containerCapacity: "",
      containerCapacityId: "",
      containerCode: "",
      containerName: "",
      remarks: "",
      containerUuid: "",
      containerImageUrl: "",
      isActive: true,
      // containerId: "",
      containerTypeId: "",
      vehicleStatusId: "",
      vehicleStatusName: "",
    });
    setTimeout(() => {
      setIsOptionsLoading(false);
    }, 1000);
  };

  const handleVehicleChange = async (e) => {
    // Destructure value and name from event target
    const { value, name } = e.target;

    // Parse value into an integer
    const intValue7 = parseInt(value, 10);

    // Find the selected vehicle status object from vehicleStatusDetails
    const selectedType = vehicleStatusDetails.find(
      (type) => type.vehicleStatusId === intValue7
    );
    // Update the state with the selected vehicle status ID and name
    setFormInput((prevData) => ({
      ...prevData,
      [name]: intValue7,
      // Set vehicleStatusName to the selected vehicle status name,
      // or an empty string if selectedType is undefined
      vehicleStatusName: selectedType
        ? selectedType.vehicleStatusName
        : "",
    }));
  };

  const handleCapacityChange = async (e) => {
    const { value } = e.target;
    setFormInput((prevData) => ({
      ...prevData,
      containerCapacityId: value,
    }));
  };

 
  const handleContainerChange = async (e) => {
    const { value, name } = e.target;

    // Parse value into an integer
    const intValue8 = parseInt(value, 10);

    // Find the selected vehicle status object from vehicleStatusDetails
    const selectedType = containerTypeData.find(
      (type) => type.containerTypeId === intValue8
    );
    // Update the state with the selected vehicle status ID and name
    setFormInput((prevData) => ({
      ...prevData,
      [name]: intValue8,
      // Set vehicleStatusName to the selected vehicle status name,
      // or an empty string if selectedType is undefined
      containerTypeName: selectedType
        ? selectedType.containerTypeName
        : "",
    }));
  };




  const options = { day: "numeric", month: "numeric", year: "numeric" };
  const generationTime = ` ${new Date()
    .toLocaleString("en-GB", options)
    .replace(/\//g, "/")}`;

  const downloadAsExcel = async () => {
    // Create a new workbook and add a worksheet
    const dataToUse = sortedData.length > 0 ? sortedData : originalData;
    const currentDate = new Date();
    const formattedDate = `${currentDate.getFullYear()}-${currentDate.getMonth() + 1
      }-${currentDate.getDate()}`;
    const formattedTime = `${currentDate.getHours()}:${currentDate.getMinutes()}:${currentDate.getSeconds()}`;
    const downloadDateTime = `Container Report Generated on: ${generationTime},${formattedTime}`;
    // Calculate the length of the downloadDateTime string
    const downloadDateTimeLength = downloadDateTime.length;
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet("Containers");

    // Define styles
    const boldFont = { bold: true };

    // Add the downloadDateTime to the correct row and columns, and ensure formatting
    worksheet.addRow(["", "", downloadDateTime, ""]); // Update array length to match new cell range
    worksheet.mergeCells(1, 2, 1, 7); // Merge cells for downloadDateTime from column 2 to 4
    worksheet.getCell(1, 2).value = downloadDateTime; // Ensure the value is set after merging
    worksheet.getCell(1, 2).font = boldFont; // Set font style
    worksheet.getCell(1, 2).alignment = { horizontal: "center" }; // Center align the content

    // Apply styles to the merged cells (B1, C1, D1)
    for (let col = 2; col <= 7; col++) {
      worksheet.getCell(1, col).font = boldFont; // Set styles individually
      worksheet.getCell(1, col).alignment = { horizontal: "center" }; // Center align the cell content
    }

    // Add "Zone Details" to the correct row and columns, and ensure formatting
    worksheet.addRow(["", "", "Containers", ""]); // Update array length to match new cell range
    worksheet.mergeCells(2, 2, 2, 7); // Merge cells for Zone Details from column 2 to 4
    worksheet.getCell(2, 2).value = "Container Details"; // Ensure the value is set after merging
    worksheet.getCell(2, 2).font = boldFont; // Set font style
    worksheet.getCell(2, 2).alignment = { horizontal: "center" }; // Center align the content

    // Apply styles to the merged cells (B2, C2, D2)
    for (let col = 2; col <= 7; col++) {
      worksheet.getCell(2, col).font = boldFont; // Set styles individually
      worksheet.getCell(2, col).alignment = { horizontal: "center" }; // Center align the cell content
    }


    // Add empty row for spacing
    worksheet.addRow([""]);

    // Add table header row with bold font
    const tableHeaderRow = worksheet.addRow([
      "S.No",
      "Container Code",
      "Container Name",
      "Container UID",
      "Container Type",
      "Vehicle Status",
      "Status"
    ]);
    tableHeaderRow.eachCell({ includeEmpty: true }, (cell, colNumber) => {
      cell.font = boldFont;
      cell.alignment = { horizontal: "left", color: "#fff" }; // Center align the cell content
      if (colNumber >= 1 && colNumber <= 11) {
        // Apply background color and set text color
        cell.fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: "F6B1B1" }, // Red background color
          bgColor: { argb: "FFFFFFFF" }, // White text color
        };
      }
    });

    // Add data rows
    dataToUse.forEach((item, index) => {
      worksheet
        .addRow([
          index + 1,
          item.containerCode,
          item.container,
          item.containerUuid,
          item.containerType,
          item.vehicleStatus,
          item.status,
        ])
        .eachCell({ includeEmpty: true }, (cell, colNumber) => {
          if (colNumber >= 1 && colNumber <= 11) {
            // Align the columns from 1 to 4 to the left
            cell.alignment = { horizontal: "left" };
          } else {
            // Align the rest of the columns to the center
            cell.alignment = { horizontal: "left" };
          }
        });
    });

    // Add total row with bold font

    // Set column widths dynamically based on content
    worksheet.columns = [
      { width: 5 },
      { width: 20 },
      { width: 20 },
      { width: 20 },
      { width: 20 },
      { width: 15 },
      { width: 15 },
      { width: 15 },
      { width: 40 },
    ];

    // Save the workbook to a file
    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = "ContainerDetails.xlsx";
    a.click();
    URL.revokeObjectURL(url);
  };

const selected = localStorage.getItem("selectedItems");
const value = selected ? JSON.parse(selected) : null;
 
  const handleDownloadQRCode = async () => {
    const zip = new JSZip();
    const qrSize = 1024;

    // Always download all QR codes from containerData
    const allItems = containerData.filter(item => item.containerUuid?.trim() !== "");
    
    console.log("Downloading all QR codes:", allItems.length);
    
    if (!allItems || allItems.length === 0) {
      toast.error("No QR codes available to download.");
      return;
    }

    const promises = allItems.map((item, index) => {
      console.log(`Processing item ${index + 1}:`, item);
      return new Promise((resolve, reject) => {
        const qr = new QRCode({
          content: item.containerUuid,
          padding: 4,
          width: qrSize,
          height: qrSize,
          color: "#000000",
          background: "#ffffff",
          ecl: "M",
        });

        const svg = qr.svg();
        const canvas = document.createElement("canvas");
        const ctx = canvas.getContext("2d");
        const img = new Image();

        img.onload = () => {
          canvas.width = qrSize;
          canvas.height = qrSize;
          ctx.drawImage(img, 0, 0, qrSize, qrSize);
          const imgData = canvas.toDataURL("image/jpeg", 1.0);
          
          // Custom paper size - tall format
          const pdf = new jsPDF("p", "mm", [90, 250]);
          const pageWidth = pdf.internal.pageSize.getWidth();
          const pageHeight = pdf.internal.pageSize.getHeight();

          // Load first logo (LSD logo)
          const logo1 = new Image();
          logo1.src = logoLSD;
          logo1.crossOrigin = "anonymous";

          // Load second logo (LMC logo)
          const logo2 = new Image();
          logo2.src = logoLMC;
          logo2.crossOrigin = "anonymous";

          logo1.onload = () => {
            logo2.onload = () => {
              // === Header with light beige background ===
              pdf.setFillColor(255, 230, 174); // Light beige color
              pdf.rect(0, 0, pageWidth, 18, 'F');
              
              // Add left logo with space
              pdf.addImage(logo1, 'PNG', 5, 3, 12, 12);
              
              // Add right logo with space
              pdf.addImage(logo2, 'PNG', pageWidth - 17, 3, 12, 12);

              // Main title in dark red
              pdf.setFont('helvetica', 'bold');
              pdf.setTextColor(153, 0, 0); // Dark red color
              pdf.setFontSize(7);
              pdf.text('LUCKNOW MUNICIPAL CORPORATION', pageWidth / 2, 9, { align: 'center' });

              // Subtitle in black
              pdf.setFontSize(6);
              pdf.setTextColor(0, 0, 0);
              pdf.text('LUCKNOW SWACHHATA ABHIYAN', pageWidth / 2, 14, { align: 'center' });

              // === QR Code in center - large size ===
              const qrWidthMM = 65; // Large QR code to match image
              const qrX = (pageWidth - qrWidthMM) / 2;
              const qrY = 18; // Positioned directly below header with no gap
              pdf.addImage(imgData, 'JPEG', qrX, qrY, qrWidthMM, qrWidthMM);

              // ==== Labels and Values ====
              const labels = [
                "EQUIPMENT ID:",
                "EQUIPMENT TYPE:",
                "EQUIPMENT CAPACITY:",
                "EQUIPMENT MAKE:",
                "UID:",
              ];
              const values = [
                item.containerCode || "-",
                item.containerType || "-",
                item.containerCapacityName || "-",
                item.containerName || "-",
                item.containerUuid || "-"
              ];

              // Create table with thin borders - narrow and centered, directly below QR code
              const tableY = qrY + qrWidthMM + 0;
              const rowHeight = 6;
              const tableWidth = 70; // Narrow table width
              const tableX = (pageWidth - tableWidth) / 2; // Center the table
              const labelWidth = 35; // Width for label column
              const valueWidth = tableWidth - labelWidth; // Width for value column

              // Thin gray borders
              pdf.setDrawColor(200, 200, 200); // Light gray color for borders
              pdf.setLineWidth(0.2); // Thin line

              for (let i = 0; i < labels.length; i++) {
                const y = tableY + i * rowHeight;
                
                // Draw table border for each row (thin gray border)
                pdf.rect(tableX, y, tableWidth, rowHeight);
                
                // Draw vertical line to separate label and value columns
                pdf.line(tableX + labelWidth, y, tableX + labelWidth, y + rowHeight);
                
                // Add label in left column - bold, black, left-aligned
                pdf.setFont('helvetica', 'bold');
                pdf.setFontSize(5.5);
                pdf.setTextColor(0, 0, 0); // Black text
                pdf.text(labels[i], tableX + 2, y + 4);
                
                // Add value in right column - bold, black, left-aligned
                pdf.setFont('helvetica', 'bold');
                pdf.setFontSize(5.5);
                pdf.setTextColor(0, 0, 0); // Black text
                pdf.text(values[i], tableX + labelWidth + 2, y + 4);
              }

              // Footer - smaller font
              pdf.setFontSize(2);
              pdf.setTextColor(100);
              pdf.setFont("helvetica", "normal");
              // pdf.text("Powered by VMax e-Solutions India Pvt Limited", pageWidth / 2, pageHeight - 1, { align: "center" });

              // Add to zip
              const pdfBlob = pdf.output("blob");
              zip.file(`${index + 1}_${item.containerCode || "QRCode"}.pdf`, pdfBlob);
              resolve();
            };
            logo2.onerror = reject;
          };
          logo1.onerror = reject;
        };
        img.onerror = reject;
        img.src = `data:image/svg+xml;charset=utf-8,${encodeURIComponent(svg)}`;
      });
    });

    try {
      await Promise.all(promises);
      const content = await zip.generateAsync({ type: "blob" });
      saveAs(content, "all_container_qrcodes.zip");
      toast.success(`ZIP file with ${allItems.length} QR codes downloaded successfully.`);
      console.log("ZIP file with PDFs generated and downloaded successfully.");
    } catch (error) {
      console.error("Error generating or downloading ZIP file:", error);
      toast.error("Error downloading QR codes. Please try again.");
    }
  };
  


  const handleSort = (sortConfig) => {
    // Assuming you have a method to sort data based on sortConfig
    const sorted = [...containerData].sort((a, b) => {
      if (sortConfig.order === 'asc') {
        return a[sortConfig.column] > b[sortConfig.column] ? 1 : -1;
      } else {
        return a[sortConfig.column] < b[sortConfig.column] ? 1 : -1;
      }
    });

    setSortedData(sorted); // Update the sorted data
  };
  const handleSortAndExport = async () => {
    if (sortConfig) {
      handleSort(sortConfig); // Apply sorting
      await new Promise((resolve) => setTimeout(resolve, 100)); // Wait for state update
    }
    const dataToExport = sortConfig ? sortedData : originalData; // Use sorted or original data
    downloadAsExcel(dataToExport); // Export the data
  };

  const searchContainerHandler = (e) => {
    const term = e.target.value.toLowerCase();
    const data = filterOriginalContainerData.filter(item => item?.containerUid?.toLowerCase()?.includes(term) || item?.containerCode?.toLowerCase()?.includes(term));
    setContainerData(data);
  }

  return (
    <>
      <div style={{ width: "100%" }}>
        <div className="content">
          <div className="page-content">
            <div className="page-header mb-0">
              <div className="row justify-content-between">
                <div className="col-md-3">
                  <div className="form-group">
                    <input
                      placeholder="Search Container UID or Container Code"
                      type="text"
                      className="form-control bg-white"
                      onInput={searchContainerHandler}
                    />
                  </div>
                </div>
                <div className="col-md-8">
                  <div className="flex_end_middle mb-3">
                    {/* {canWriteValue === true ? */}
                      <button className="button-container" onClick={handleShow}>
                        <i className="fa-solid fa-plus me-1 icon-container"></i>
                        {t("addContainer")}
                      </button>
                      {/* : ''} */}
                    <button className="btn btn-excel"
                      onClick={handleSortAndExport}>
                      <i class="fa-solid fa-file-excel me-1 icon-container"></i> Excel
                    </button>
                    {/* {isChecked === "true"? */}
                    <button className="btn btn-excel" onClick={handleDownloadQRCode}>
                      <i class="fa-regular fa-file-pdf me-1 icon-container"></i>
                      Download QR
                    </button>
                    {/* :""} */}
                    {/* {checkedValue === 'true' ? // Conditionally render the button */}
                    {/* <button
                    className="btn btn-danger"
                    style={{ backgroundColor: "#EC1117" }}
                    onClick={handleDownloadQRCode}
                  >
                    Download QR
                  </button> */}
                    {/* :""
                } */}
                  </div>
                </div>
              </div>
            </div>
            {/* {JSON.parse(localStorage.getItem("selected"))?.map((item, index) => (
              <QRCode
                key={index}
                id="qrCode"
        // style={{ margin: "5px auto", padding: "5px", background: "#fff" }}
        // dangerouslySetInnerHTML={{ __html: generateQRCodeSVG(item) }}
                value={item.containerUuid}
                style={{ display: "none" }}
              />
            ))} */}
            <div className="card">
              <div className="card-body">
                <div className="top-header">
                  <span>{t("container")}</span>
                </div>
                <TableComponent
                  DataFetchURL={containerData}
                  headers={headers}
                  filterFunction={(data) =>
                    data.filter(
                      (item) => item.status === 1 || item.status === 0
                    )
                  }
                  editData={handleEditContainer}
                  editContainerData={editContainerData}
                  viewData={(id) => handleViewContainerData(id)}
                  onSort={handleSort}
                />
                {/* <CustomDataTable
                  columns={scvCircleReportColumns}
                  data={containerData}
                  // headers={headers}
                    // filterFunction={(data) =>
                    //   data.filter(
                    //     (item) => item.status === 1 || item.status === 0
                    //   )
                    // }
                    // editData={handleEditContainer}
                    // editContainerData={editContainerData}
                  /> */}
              </div>
            </div>
          </div>
        </div>
      </div>
      {isOptionsLoading && <Loader />}
      <Modal
        size="lg"
        show={lgShow}
        onHide={() => setLgShow(false)}
        aria-labelledby="example-modal-sizes-title-lg"
        backdrop="static"
      >
        <Modal.Header>
          <Modal.Title id="example-modal-sizes-title-lg">
            {selectedContainer ? "Edit Container" : "Add Container"}
          </Modal.Title>
          <i
            class="fa-solid fa-xmark close-container"
            onClick={handleClose}
          ></i>
        </Modal.Header>
        <hr />
        <Modal.Body>
          <form
            onSubmit={handleSubmit(addNewContainer)}
            onKeyDown={(e) => {
              handleKeyDown(e, handleSubmit);
            }}
          >
            <div className="row">
              {/* {selectedContainer ? ( */}
              <div className="col-md-4" style={{ display: "none" }}>
                <div className="form-group">
                  <label className="form-label">Container Id</label>
                  <input
                    type="number"
                    className="form-control"
                    name="containerId"
                    {...register("containerId")}
                    value={formInput.containerId}
                    readOnly
                    onChange={(e) =>
                      setFormInput({
                        ...formInput,
                        containerId: e.target.value,
                      })
                    }
                    // disabled={!canWriteValue}
                  />
                </div>
              </div>
              {/* ) : (
                ""
              )} */}
              <div className="col-md-4">
                <div className="form-group">
                  <label className="form-label">
                    Container Code<span style={{ color: "#EC1117" }}> *</span>
                  </label>
                  <input
                    type="text"
                    className={`form-control ${formInput.containerCode || !formSubmitted
                      ? ""
                      : "input-error"
                      }`}
                    name="containerCode"
                    placeholder="Enter Container Code"
                    {...register("containerCode")}
                    value={formInput.containerCode}
                    onChange={(e) => {
                      const inputValue = e.target.value;
                      const sanitizedValue = inputValue.replace(
                        /[^a-zA-Z0-9]/g,
                        ""
                      );
                      setFormInput({
                        ...formInput,
                        containerCode: sanitizedValue,
                      });
                    }}
                    // disabled={!canWriteValue}
                    maxLength={15}
                  />
                  {!formInput.containerCode && formSubmitted && (
                    <div className="required-message">
                      Container Code is Required
                    </div>
                  )}
                </div>
              </div>
              <div className="col-md-4 ">
                <div className="form-group">
                  <label className="form-label">
                    Container<span style={{ color: "#EC1117" }}> *</span>
                  </label>
                  <input
                    type="text"
                    placeholder="Enter Container"
                    className={`form-control ${formInput.containerName || !formSubmitted
                      ? ""
                      : "input-error"
                      }`}
                    name="containerName"
                    {...register("containerName")}
                    value={formInput.containerName}
                    maxLength={42}
                    onChange={(e) =>
                      setFormInput({
                        ...formInput,
                        containerName: e.target.value,
                      })
                    }
                    // disabled={!canWriteValue}
                  />

                  {!formInput.containerName && formSubmitted && (
                    <div className="required-message">
                      Container is Required
                    </div>
                  )}
                </div>
              </div>
              <div className="col-md-4 ">
                <div className="form-group">
                  <label className="form-label">
                    Container UID <span style={{ color: "#EC1117" }}> *</span>
                  </label>
                  <input
                    type="text"
                    placeholder="Enter Container UID"
                    className={`form-control ${formInput.containerUuid || !formSubmitted
                      ? ""
                      : "input-error"
                      }`}
                    name="containerUuid"
                    {...register("containerUuid")}
                    value={formInput.containerUuid}
                    maxLength={20}
                    onChange={(e) => {
                      const inputValue = e.target.value;
                      const sanitizedValue = inputValue.replace(
                        /[^a-zA-Z0-9/]/g,
                        ""
                      );
                      setFormInput({
                        ...formInput,
                        containerUuid: sanitizedValue.toUpperCase(),
                      });
                    }}
                    // disabled={!canWriteValue}
                  />

                  {!formInput.containerUuid && formSubmitted && (
                    <div className="required-message">
                      Container UID is Required
                    </div>
                  )}
                </div>
              </div>

              {/* <div className="col-md-4 ">
                <div className="form-group">
                  <label className="form-label">Container Capacity <span style={{ color: '#EC1117' }}> *</span></label>
                  <input
                    type="text"
                    className={`form-control ${formInput.containerCapacity || !formSubmitted ? "" : "input-error"
                      }`}
                    name="containerCapacity"
                    {...register("containerCapacity")}
                    value={formInput.containerCapacity}
                    onChange={(e) =>
                      setFormInput({
                        ...formInput,
                        containerCapacity: e.target.value,
                      })
                    }
                  />
                  {!formInput.containerCapacity && formSubmitted && (
                    <div className="required-message">
                      Required.
                    </div>
                  )}
                </div>
              </div> */}
              <div className="col-md-4 mb-3">
                <div className="form-group">
                  <label htmlFor="containerCapacity">
                    Container Capacity{" "}
                    <span style={{ color: "#EC1117" }}> *</span>
                  </label>
                  <select
                    className={`form-select ${formInput.containerCapacityId || !formSubmitted
                      ? ""
                      : "input-error"
                      }`}
                    id="containerCapacity"
                    name="containerCapacityId"
                    // placeholder="Enter Container Capacity"
                    {...register("containerCapacityId")}
                    value={formInput.containerCapacityId}
                    onChange={handleCapacityChange}
                    // disabled={!canWriteValue}
                  >
                    <option value="">Select</option>
                    {containerCapacityData.map((capacity) => (
                      <option
                        key={capacity.containerCapacityId}
                        value={capacity.containerCapacityId}
                      >
                        {capacity.containerCapacityName}
                      </option>
                    ))}
                  </select>
                  {!formInput.containerCapacityId && formSubmitted && (
                    <div className="required-message">
                      Container Capacity is Required
                    </div>
                  )}
                </div>
              </div>
              <div className="col-md-4 mb-3">
                <div className="form-group">
                  <label htmlFor="containerType">
                    Type Of Container{" "}
                    <span style={{ color: "#EC1117" }}> *</span>
                  </label>
                  <select
                    className={`form-select ${formInput.containerTypeId || !formSubmitted
                      ? ""
                      : "input-error"
                      }`}
                    id="containerType"
                    name="containerTypeId"
                    //placeholder="Enter Container Type"
                    {...register("containerTypeId")}
                    value={formInput.containerTypeId}
                    onChange={handleContainerChange}
                  // disabled={!canWriteValue}
                  >
                    <option value="">Select</option>
                    {containerTypeData.map((type) => (
                      <option
                        key={type.containerTypeId}
                        value={type.containerTypeId}
                      >
                        {type.containerTypeName}
                      </option>
                    ))}
                  </select>
                  {!formInput.containerTypeId && formSubmitted && (
                    <div className="required-message">
                      Type Of Container is Required
                    </div>
                  )}
                </div>
              </div>
              {/* <div className="col-md-4 ">
                <div className="form-group">
                  <label className="form-label">Type Of Container <span style={{ color: '#EC1117' }}> *</span></label>
                  <input
                    type="text"
                    className={`form-control ${formInput.containerType || !formSubmitted ? "" : "input-error"
                      }`}
                    name="containerType"
                    {...register("containerType")}
                    value={formInput.containerType}
                    onChange={(e) =>
                      setFormInput({
                        ...formInput,
                        containerType: e.target.value,
                      })
                    }
                  />
                  {!formInput.containerType && formSubmitted && (
                    <div className="required-message">
                      Type Of Container is Required
                    </div>
                  )}
                </div>
              </div> */}
              <div className="col-md-4 mb-3">
                <div className="form-group">
                  <label htmlFor="vehicleStatus">
                    Vehicle Status <span style={{ color: "#EC1117" }}> *</span>
                  </label>
                  <select
                    className={`form-select ${formInput.vehicleStatusId || !formSubmitted
                      ? ""
                      : "input-error"
                      }`}
                    id="vehicleStatus"
                    name="vehicleStatusId"
                    // placeholder="Enter Vehicle Status"
                    {...register("vehicleStatusId")}
                    value={formInput.vehicleStatusId}
                    onChange={handleVehicleChange}
                    // disabled={!canWriteValue}
                  >
                    <option value="">Select</option>
                    {vehicleStatusDetails.map((status) => (
                      <option
                        key={status.vehicleStatusId}
                        value={status.vehicleStatusId}
                      >
                        {status.vehicleStatusName}
                      </option>
                    ))}
                  </select>
                  {!formInput.vehicleStatusId && formSubmitted && (
                    <div className="required-message">
                      Vehicle Status is Required
                    </div>
                  )}
                </div>
              </div>
              <div className="col-md-4 ">
                <div className="form-group">
                  <label className="form-label">Remarks</label>
                  <input
                    type="text"
                    placeholder="Enter Remarks"
                    className="form-control "
                    name="remarks"
                    {...register("remarks")}
                    value={formInput.remarks}
                    maxLength={500}
                    onChange={(e) =>
                      setFormInput({
                        ...formInput,
                        remarks: e.target.value,
                      })
                    }
                    // disabled={!canWriteValue}
                  />
                  {/* {!formInput.remarks && formSubmitted && (
                    <div className="required-message">
                      Remarks is Required
                    </div>
                  )} */}
                </div>
              </div>
              <div className="col-md-4 ">
                <div className="form-group">
                  <label className="form-label">
                    Upload File
                  </label>
                  <input
                    type="file"
                    className="form-control"
                    name="containerImageUrl"
                    accept=".png, .jpg, .jpeg"
                    {...register("containerImageUrl")}
                    onChange={(e) => {
                      setFormInput({
                        ...formInput,
                        containerImageUrl: e.target.files[0],
                      });
                      handleImageChange(e);
                    }}
                    // disabled={!canWriteValue}
                  />
                  {/* {!formInput.containerImageUrl && formSubmitted && (
                    <div className="required-message">
                      Upload File i Require
                    </div>
                  )} */}
                  {imagePreview && (
                    <img style={{ width: "100%", marginTop: "20px" }}
                      src={imagePreview}
                      alt="Vehicle Image"
                    />
                  )}
                </div>
              </div>
              <div className="col-md-4"></div>
              {/* {selectedContainer ? ( */}
              <div className="col-md-4 mt-2">
                <label className="form-label">
                  Status <span style={{ color: "#EC1117" }}> *</span>
                </label>
                <div className="form-group" style={{ display: "flex" }}>
                  <div className="form-check">
                    <input
                      type="radio"
                      className="form-check-input"
                      name="isActive"
                      id="activeRadio"
                      {...register("isActive")}
                      value="true"
                      checked={formInput.isActive === true}
                      // onChange={() =>
                      //   setFormInput({ ...formInput, isActive: "true" })
                      // }
                      onChange={handleStatusChange}
                    />
                    <label className="form-check-label" htmlFor="activeRadio">
                      Active
                    </label>
                  </div>
                  <div className="form-check" style={{ marginLeft: "60px" }}>
                    <input
                      type="radio"
                      className="form-check-input"
                      name="isActive"
                      id="inactiveRadio"
                      {...register("isActive")}
                      value="false"
                      checked={formInput.isActive === false}
                      // onChange={() =>
                      //   setFormInput({ ...formInput, isActive: "false" })
                      // }
                      onChange={handleStatusChange}
                    />
                    <label className="form-check-label" htmlFor="inactiveRadio">
                      InActive
                    </label>
                  </div>
                </div>
              </div>
              {/* ) : (
                ""
              )} */}
            </div>
            <div className="modal-footer d-flex justify-content-center">
              {/* {canWriteValue === true ? */}
                <button type="submit" className="deployment-button">
                  <i class="fa-solid fa-check done-container"></i>
                  {selectedContainer ? t("Update") : t("Save")}
                </button>
                {/* // : ''} */}
            </div>
          </form>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default withTranslation()(ContainerMaster);